"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { MoveReview } from "@/lib/chess/review";
import { positionKey } from "@/lib/chess/study";

export type CameraPreset = "club" | "overhead" | "table";
export type SavedPosition = { id: string; move: MoveReview; opponent: string; opponentRating?: number; playerRating?: number; opening: string; savedAt: string; note: string; pgn: string; playerColor: "w" | "b" };
type Preferences = {
  camera: CameraPreset; sound: boolean; focus: boolean; preferredColor: "w" | "b" | "random";
  notebook: SavedPosition[];
  update: (patch: Partial<Pick<Preferences, "camera" | "sound" | "focus" | "preferredColor">>) => void;
  save: (position: Omit<SavedPosition, "id" | "savedAt" | "note">) => void;
  annotate: (id: string, note: string) => void;
  remove: (id: string) => void;
};
export const usePlayPreferences = create<Preferences>()(persist((set) => ({
  camera: "club", sound: false, focus: false, preferredColor: "w", notebook: [],
  update: (patch) => set(patch),
  save: (position) => set((s) => {
    const id = positionKey(position.move.fenBefore);
    if (s.notebook.some((p) => p.id === id)) return s;
    return { notebook: [{ ...position, id, savedAt: new Date().toISOString(), note: "" }, ...s.notebook] };
  }),
  annotate: (id, note) => set((s) => ({ notebook: s.notebook.map((p) => p.id === id ? { ...p, note: note.slice(0, 1000) } : p) })),
  remove: (id) => set((s) => ({ notebook: s.notebook.filter((p) => p.id !== id) })),
}), { name: "ponder:playing-room", version: 1, skipHydration: true }));
